import React from 'react';
import Dropdown from "../Dropdown";
import LoginDropdown from '../LoginDropdown';

const AuthDropdown = ({ t, openAuthModal, toggleEl, baseClassName, loginText, signupText, parentClassName, align  , isRtl}) => (
  <div className={`${baseClassName}__auth-dropdown`}>
    <Dropdown isContentRtl={isRtl} toggleEl = {toggleEl} parentClassName={parentClassName} align={align}>
      <LoginDropdown LoginText={loginText} signupText={signupText} onClickLogin={openAuthModal} />
    </Dropdown>
  </div>
);

export default AuthDropdown;


// WEBPACK FOOTER //
// ./src/components/AuthDropdown/AuthDropdown.jsx